import { customAutoCompleteFilter, customDatePickerFilterNullable, standardGridPageSize } from "../../../GlobalVariables/filterVariables";

export default /*@ngInject*/ function (helperService, userProfileDataService, connectionsDataService, $http) {
    const vm = this;
    vm.helperService = helperService;

    vm.accessCollapsed = true;
    vm.userProductCollapsed = true;
    vm.customLogo = null;

    vm.$onInit = activate;

    async function activate() {
        await aLAPluginActive();
        await getProductLogo();
        setupGrid();
    }

    async function aLAPluginActive() {
        let response = await $http.get(`${apiUrl}/api/core/plugins`);
        vm.aLAPluginActive = response.data.some(plugin => plugin.Id === 9 && plugin.Active);
    }

    async function getProductLogo() {
        try {
            const { data } = await connectionsDataService.getProductLogo(vm.product.User.ProductId);
            vm.customLogo = data;
        } catch {
            vm.customLogo = null;
        }
    }

    function setupGrid() {
        let productProfileAccessGridColumns = [
            { field: "SecurityObjectName", title: "Object Name", width: 120, filterable: customAutoCompleteFilter },
            { field: "SecurityObjectAltName", title: "Object Label", width: 120, filterable: customAutoCompleteFilter },
            { field: "SecurityObjectTypeName", title: "Object Type", width: 120, filterable: customAutoCompleteFilter },
            { field: "AccessTypeName", title: "Access Type", width: 120, filterable: customAutoCompleteFilter },
            { field: "AccessLevelName", title: "Access Level", width: 120, filterable: customAutoCompleteFilter },
        ];
        
        if (vm.aLAPluginActive) {
            const lastUsedCol = { field: "LastUsed", title: "Last Used", template: "{{ dataItem.LastUsed | date:'short'}}", width: 200, filterable: customDatePickerFilterNullable },
                viewCountCol = { field: "ViewCount", title: "View Count", width: 130, filterable: customAutoCompleteFilter };

            productProfileAccessGridColumns.push(lastUsedCol);
            productProfileAccessGridColumns.push(viewCountCol);
        }

        vm.productProfileAccessGridOptions = helperService.setMainGridOptions(productProfileAccessGridColumns, 400);
        vm.productProfileAccessGridOptions.autoBind = true;

        vm.productProfileAccessGridDataSource = new kendo.data.DataSource({
            pageSize: standardGridPageSize,
            schema: {
                model: {
                    fields: {
                        LastUsed: { type: "date" },
                        ViewCount: { type: "number" }
                    }
                }
            },
            transport: {
                read: async options => {
                    try {
                        const { data } = await userProfileDataService.getUserProfileAccess(vm.product.User.UserId, vm.product.User.ProductId);
                        options.success(data);
                    } catch (err) {
                        return;
                    }
                }
            }
        });
    }
}